import {InformatDefaultPage} from "../../../04templates/informat/defaultPage/InformatDefaultPage";
import {GridContainer, GridItem, GridRow} from "pu-crossproduct-components/build/components/Atoms/Grid";
import {Trans, useTranslation} from "react-i18next";
import styled from "styled-components";
import {Body2, H1} from "pu-crossproduct-components/build/components/Atoms/Type/"
import {
    CardColor,
    CardSize,
    LogoCard,
    Logos,
    TagColors
} from "pu-crossproduct-components/build/components/Organisms/Navigation/Card";
import {Loading} from "pu-crossproduct-components/build/components/Organisms/Loading";

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-top: 36px;
`

const CardHolder = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  max-width: 800px;
  & > * {
    margin: 12px 12px 12px 12px;
  }
`




export const InformatAccountPickerLoading: React.FC = props => {
    const {t} = useTranslation();


    return <InformatDefaultPage>

        <GridContainer>
            <GridRow>
                <GridItem col={0} laptop={2}/>
                <GridItem col={12} laptop={8}>
                    <Content>
                        <H1><Trans t={t}>twoFactorInformatAccountPickerLoadingTitle</Trans></H1>
                        <Loading>
                            <Body2><Trans t={t}>twoFactorInformatAccountPickerLoadingDescription</Trans></Body2>
                        </Loading>
                    </Content>
                </GridItem>
                <GridItem col={0} laptop={2}/>
            </GridRow>
        </GridContainer>
    </InformatDefaultPage>
}
